import { apiClient } from './client'
import type { FavoriteToggleResponse, SavedProjectsPage } from './types'

export const favoriteProject = async (projectId: string): Promise<FavoriteToggleResponse> => {
  const response = await apiClient.post<FavoriteToggleResponse>(
    `/api/v1/projects/${projectId}/favorite`
  )
  return response.data
}

export const unfavoriteProject = async (projectId: string): Promise<FavoriteToggleResponse> => {
  const response = await apiClient.delete<FavoriteToggleResponse>(
    `/api/v1/projects/${projectId}/favorite`
  )
  return response.data
}

/**
 * Single-project favorite-stats — used by Project Detail to populate the header heart + count.
 * Fetched in parallel with the project hydrate query (see PHASE10_STATUS.md for the
 * modulith-cycle rationale — these fields aren't on ProjectDetail itself).
 */
export const getFavoriteStats = async (projectId: string): Promise<FavoriteToggleResponse> => {
  const response = await apiClient.get<FavoriteToggleResponse>(
    `/api/v1/projects/${projectId}/favorite`
  )
  return response.data
}

/**
 * Bulk enrichment for browse-card hearts. Returns the subset of supplied project ids that the
 * current user has favorited. Auth-gated — the SPA only calls it when the viewer is signed in.
 */
export const getFavoritedProjectIdsAmong = async (projectIds: string[]): Promise<string[]> => {
  if (projectIds.length === 0) return []
  const params = new URLSearchParams()
  for (const id of projectIds) params.append('projectIds', id)
  const response = await apiClient.get<string[]>(
    `/api/v1/me/favorited-project-ids?${params.toString()}`
  )
  return response.data
}

interface ListSavedOptions {
  page?: number
  size?: number
}

export const listSavedProjects = async (
  options: ListSavedOptions = {}
): Promise<SavedProjectsPage> => {
  const params = new URLSearchParams()
  if (options.page != null) params.set('page', String(options.page))
  if (options.size != null) params.set('size', String(options.size))
  const qs = params.toString()
  const response = await apiClient.get<SavedProjectsPage>(
    `/api/v1/me/favorites${qs ? '?' + qs : ''}`
  )
  return response.data
}
